import { useState } from 'react';
import {
  Box,
  CardMedia,
} from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import CloseIcon from '@mui/icons-material/Close';
import { ImageWithFallback } from '../../helper/helper';

export default function GoalMedia({ selectedGoal, BlankImg }) {
  const [showVideo, setShowVideo] = useState(false);

  // Helper: Render a <video> tag for direct MP4 links, or iframe for YouTube/Vimeo
  function renderVideo(video_link) {
    if (!video_link) return null;
    if (video_link.endsWith('.mp4')) {
      // Direct MP4 file
      return (
        <video width="100%" height="100%" controls autoPlay style={{ borderRadius: 8 }}>
          <source src={video_link} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      );
    }
    // Otherwise, treat as YouTube/Vimeo and embed
    let embedUrl = video_link;
    if (video_link.includes('youtube') || video_link.includes('youtu.be')) {
      // Get the YouTube video ID
      const match = video_link.match(/(?:youtube\.com.*(?:\/|v=)|youtu\.be\/)([^&?/]+)/);
      const youtubeId = match ? match[1] : '';
      embedUrl = `https://www.youtube.com/embed/${youtubeId}`;
      return (
        <iframe
          width="100%"
          height="200"
          src={embedUrl}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          style={{ borderRadius: 8 }}
        ></iframe>
      );
    }
    // Add similar handling for Vimeo if you wish
    return <div>Unsupported video format.</div>;
  }

  return (
    <CardMedia>
      <Box className="p_image" sx={{ position: 'relative', height: '200px' }}>
        {!showVideo ? (
          <>
            <ImageWithFallback
              src={selectedGoal?.thumbnail}
              alt={''}
              fallbackSrc={BlankImg}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                borderRadius: '8px'
              }}
            />
            <Box
              className="playIcon-wrapper"
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                zIndex: 2
              }}
            >
              <PlayArrowIcon
                className="playIcon"
                sx={{ fontSize: '40px', color: 'white', cursor: 'pointer' }}
                onClick={() => setShowVideo(true)}
              />
            </Box>
          </>
        ) : (
          <Box
            sx={{
              width: '100%',
              height: '100%',
              background: 'black',
              borderRadius: '8px',
              position: 'relative'
            }}
          >
            <Box
              sx={{
                position: 'absolute',
                top: 8,
                right: 8,
                zIndex: 3,
                cursor: 'pointer',
                color: 'white',
                background: 'rgba(0,0,0,0.4)',
                borderRadius: '50%'
              }}
              onClick={() => setShowVideo(false)}
            >
              <CloseIcon sx={{ fontSize: 24 }} />
            </Box>
            {renderVideo(selectedGoal?.video_link)}
          </Box>
        )}
      </Box>
    </CardMedia>
  );
}
